import React from 'react';
import styled from 'styled-components';
import ReleasingCalculatorForm from './ReleasingCalculatorForm';
import { BodyLink, NextIcon } from '@kvdbil/components';
import { ReleasingObjectInfo } from './ReleasingService';
import { CMSDataObjectPageService } from '~/App/views/ObjectPage/cmsDataHandlers';
import StructuredText from '~/App/components/DatoCMS/StructuredText';
import Link from '~/App/shared/components/Link';

const ReleasingInformationContainer = styled.div`
  padding: 1em 1em 2em 1em;
`;

const ReleasingInformationDescription = styled(StructuredText)`
  p {
    font-weight: normal;
  }

  li {
    margin-bottom: 1em;

    &:before {
      width: 16px;
      height: 16px;
      background-image: url('/images/icons/icon-check-blue.png');
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      content: '';
      display: inline-block;
      margin-right: 0.5em;
    }
  }
`;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
`;

interface Props {
  cmsData: CMSDataObjectPageService;
  isBuyNow: boolean;
  objectInfo: ReleasingObjectInfo;
  showReleasingForm?: boolean;
  isReleasingManualCheckout?: boolean;
  id: string;
}

const ReleasingInformation = ({
  cmsData,
  isBuyNow,
  objectInfo,
  showReleasingForm = false,
  id
}: Props) => {
  const linkData = cmsData?.link[0];

  return (
    <ReleasingInformationContainer id={id}>
      <ReleasingInformationDescription data={cmsData?.content} />
      {showReleasingForm ? (
        <ReleasingCalculatorForm
          objectInfo={objectInfo}
          buttonText={linkData.text ?? ''}
          isBuyNow={isBuyNow}
        />
      ) : (
        <StyledLink to={linkData.url ?? ''} target="_blank">
          <BodyLink as="span">{linkData.text}</BodyLink>
          <NextIcon />
        </StyledLink>
      )}
    </ReleasingInformationContainer>
  );
};

export default ReleasingInformation;
